import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SqlModelingState } from './sql-modeling.model';
import { SqlModelingStore } from './sql-modeling.store';

@Injectable({ providedIn: 'root' })
export class SqlModelingStoreQuery extends QueryEntity<SqlModelingState> {
  constructor(protected readonly store: SqlModelingStore) {
    super(store);
  }
}
